import {combineReducers} from 'redux';

import {UserOrdersActions, getUserOrdersActionTypes, IUserOrdersState} from '../types';
import {makeCommunicationReducerFromEnum} from 'Common/store/utils/communication';

export const communicationReducer = combineReducers<IUserOrdersState['communications'], UserOrdersActions>({
  userOrdersLoading: makeCommunicationReducerFromEnum(getUserOrdersActionTypes)
});
